namespace Matrix.Rebalancer {
    export interface SessionForm {
        SessionId: Serenity.StringEditor;
        SessionInstanceId: Serenity.StringEditor;
        BaseCurrency: Serenity.LookupEditor;
        PreparedBy: Serenity.StringEditor;
        PreparedWhen: Serenity.StringEditor;
        ApprovedBy: Serenity.StringEditor;
        ApprovedWhen: Serenity.StringEditor;
        SessionType: Serenity.StringEditor;
        Version: StaticTextBlock;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
    }

    export class SessionForm extends Serenity.PrefixedContext {
        static formKey = 'Rebalancer.Session';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SessionForm.init)  {
                SessionForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = StaticTextBlock;
                var w3 = ReadOnlyDateTime;

                Q.initFormType(SessionForm, [
                    'SessionId', w0,
                    'SessionInstanceId', w0,
                    'BaseCurrency', w1,
                    'PreparedBy', w0,
                    'PreparedWhen', w0,
                    'ApprovedBy', w0,
                    'ApprovedWhen', w0,
                    'SessionType', w0,
                    'Version', w2,
                    'CreatedBy', w2,
                    'CreatedWhen', w3,
                    'UpdatedBy', w2,
                    'UpdatedWhen', w3
                ]);
            }
        }
    }
}
